// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `iframe {
  border: none !important;
  margin-top: var(--ion-safe-area-top);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/payment/components/pay-with-wrapper/components/pay-with-payrexx/components/payrexx-iframe-wrapper/payrexx-iframe-wrapper.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,oCAAA;AACF","sourcesContent":["iframe {\n  border: none !important;\n  margin-top: var(--ion-safe-area-top);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
